import React from 'react';

export const WakeLockContext = React.createContext({});